import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth-context";
import { BackendStatusBanner } from "./components/BackendStatusBanner";
import { router } from "./router";
import "./styles.css";

// Sentry condicional: no-op se VITE_SENTRY_DSN nao estiver definida.
const sentryDsn = import.meta.env["VITE_SENTRY_DSN"] as string | undefined;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env["MODE"] ?? "production",
    // Sem tracing por padrao (evita custo de quota).
    tracesSampleRate: 0,
    // LGPD: nao enviar dados pessoais automaticamente.
    sendDefaultPii: false,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Elemento #root não encontrado no DOM.");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BackendStatusBanner />
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
